var map = {
  "./shape-diamond-aquamarine-gradient.png": "91301",
  "./shape-diamond-aquamarine-light.png": "96021",
  "./shape-diamond-aquamarine.png": "81124",
  "./shape-diamond-blue-gradient.png": "85285",
  "./shape-diamond-blue-light.png": "47609",
  "./shape-diamond-blue.png": "64489",
  "./shape-diamond-cyan-gradient.png": "49642",
  "./shape-diamond-cyan-light.png": "23025",
  "./shape-diamond-cyan.png": "75073",
  "./shape-diamond-green-gradient.png": "12947",
  "./shape-diamond-green-light.png": "1502",
  "./shape-diamond-green.png": "10533",
  "./shape-diamond-grey100.png": "53623",
  "./shape-diamond-grey1000.png": "29401",
  "./shape-diamond-grey200.png": "70714",
  "./shape-diamond-grey25.png": "84754",
  "./shape-diamond-grey300.png": "53080",
  "./shape-diamond-grey400.png": "47910",
  "./shape-diamond-grey50.png": "76476",
  "./shape-diamond-grey500.png": "31581",
  "./shape-diamond-grey600.png": "13376",
  "./shape-diamond-grey700.png": "20034",
  "./shape-diamond-grey800.png": "75183",
  "./shape-diamond-grey900.png": "6049",
  "./shape-diamond-indigo-gradient.png": "81696",
  "./shape-diamond-indigo-light.png": "70152",
  "./shape-diamond-indigo.png": "26278",
  "./shape-diamond-lime-gradient.png": "74398",
  "./shape-diamond-lime-light.png": "63324",
  "./shape-diamond-lime.png": "94144",
  "./shape-diamond-magenta-gradient.png": "42120",
  "./shape-diamond-magenta-light.png": "36378",
  "./shape-diamond-magenta.png": "55027",
  "./shape-diamond-navy-gradient.png": "68632",
  "./shape-diamond-navy-light.png": "4289",
  "./shape-diamond-navy.png": "6509",
  "./shape-diamond-orange-gradient.png": "17305",
  "./shape-diamond-orange-light.png": "2797",
  "./shape-diamond-orange.png": "84070",
  "./shape-diamond-purple-gradient.png": "82885",
  "./shape-diamond-purple-light.png": "34557",
  "./shape-diamond-purple.png": "4196",
  "./shape-diamond-red-gradient.png": "98098",
  "./shape-diamond-red-light.png": "75135",
  "./shape-diamond-red.png": "93373",
  "./shape-diamond-yellow-gradient.png": "69230",
  "./shape-diamond-yellow-light.png": "48435",
  "./shape-diamond-yellow.png": "63020"
};


function webpackContext(req) {
  var id = webpackContextResolve(req);
  return __webpack_require__(id);
}
function webpackContextResolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
webpackContext.keys = function webpackContextKeys() {
  return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78312;
